import React, { useState, useEffect } from 'react';
import AppearAnimation from '../components/AppearAnimation'
import { Alert } from 'react-bootstrap'
 
const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
 
  useEffect(() => {
    setTimeout(() => {
        const cookieChoice = localStorage.getItem('cookieConsent');
        if (!cookieChoice) {
        setShowBanner(true);
        }
    }, 3000)
  }, [])
 
  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false)
    // Qui in futuro va agganciato l'avvio effettivo degli script non tecnici
    // (analytics, pixel pubblicitari) SOLO dopo l'accettazione.
  }
 
  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false)
    // Con il rifiuto, nessun cookie non tecnico deve essere installato:
    // verificare che script di analytics/ads non partano già a prescindere.
  }
 
  return (
    <div className='fixed-bottom '>
        <AppearAnimation>
        {showBanner && (
        <Alert variant="light" >
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
            <p className="mb-0">
              Utilizziamo cookie tecnici necessari al funzionamento del sito e, previo consenso, cookie di
              profilazione per mostrarti annunci pertinenti. Consulta la nostra{' '}
              <a href="//www.iubenda.com/privacy-policy/62630212" target="_blank" rel="noreferrer">privacy policy</a>
              {' '}e la{' '}
              <a href="//www.iubenda.com/privacy-policy/62630212/cookie-policy" target="_blank" rel="noreferrer">cookie policy</a>.
            </p>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary btn-sm" onClick={rejectCookies}>Rifiuta tutti</button>
              <button className="btn btn-primary btn-sm" onClick={acceptCookies}>Accetta tutti</button>
            </div>
          </div>
        </Alert>
    )}
    </AppearAnimation>
    </div>
  );
};
 
export default CookieBanner;